import {Component, OnInit} from '@angular/core';
import {AdmissionService} from "../admission.service";

@Component({
  selector: 'app-appl-result',
  templateUrl: './appl-result.component.html',
  styleUrls: ['./appl-result.component.css']
})
export class ApplResultComponent implements OnInit {


  constructor(private appl: AdmissionService) {

  }


  ngOnInit(): void {
  }

}
